import Layout from 'Layout'
import ProductSlider from './ProductSlider';
import ProductContent from './ProductContent';
import ProductContent2 from './ProductContent2';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './styles.scss'
import { useEffect, useState } from 'react';
import { mixGetV1 } from 'services/mixin';
import ScrollUnlocker from 'components/FixScroll/ScrollUnlocker';
import { message } from 'antd';
import { Helmet } from 'react-helmet-async';
import { getUnreadCount } from 'pages/Notifications/function';
import { useTranslation } from 'react-i18next';

interface productProps {
	id: number
	product_id: string
	product: any
	title: string
	subtitle: string
	point_price: number
	locale: string
	image: string
	description: string
	numbers: {
		life_path: number
	}
	created_at: string
	updated_at: string
	introduction: string | null
	bonuses: any
	point_price_formatted: string
	image_url: string
}


function Products() {

	const [products, setProducts] = useState<productProps[]>([])
	const [boughtProducts, setBoughtProducts] = useState<productProps[]>([])
	const { t, i18n } = useTranslation();
	const lang = i18n.language;
	const [product2, setProducts2] = useState<productProps[]>([])
	const [notificationCount, setNotificationCount] = useState(0)
	useEffect(() => {
		getUnreadCount().then((count) => {
			setNotificationCount(count);
		});
	}, []);

	function formatToDDMMYYYY(dateTimeStr: string) {
		if (!dateTimeStr || typeof dateTimeStr !== 'string') return null;

		const datePart = dateTimeStr.split(' ')[0];

		const parts = datePart.includes('-') ? datePart.split('-') : datePart.split('/');

		if (parts.length < 3) return null;

		const [year, month, day] = parts;

		const dd = String(day).padStart(2, '0');
		const mm = String(month).padStart(2, '0');
		const yyyy = String(year);

		return `${dd}/${mm}/${yyyy}`;
	}

	const getRecommend = async () => {
		const localData = localStorage.getItem('user') as any

		if (localData) {

			const handledData = JSON.parse(localData)

			try {
				const res = await mixGetV1(`/api/v1/be/products?locale=${lang}&full_name=${handledData.fullname}&date_of_birth=${formatToDDMMYYYY(handledData.birthday)}`)

				const res2 = await mixGetV1(`/api/v1/be/products?locale=${lang}&page=1&is_featured=1&limit=50`)

				if (res.status) {
					const fillterData = res.data.items.filter((item: any) => item.image !== null)
					console.log("fillterData", fillterData)
					setProducts(fillterData)
				}

				if (res2.status) {
					const fillterData2 = res2.data.items.filter((item: any) => item.image !== null)
					console.log("fillterData2", fillterData2)
					setProducts2(fillterData2)
				}
			} catch (error: any) {
				message.error("Failed call data", error);
			}
		}
	}

	const getBoughtProducts = async () => {
		const localData = localStorage.getItem('user')

		if (localData) {
			const data = JSON.parse(localData)
			try {
				const res = await mixGetV1(
					`/api/v1/be/orders?locale=${lang}&user_id=${data.id}`
				);

				//`/api/v1/be/orders?locale=en&user_id=${data.id}&status=paid`

				if (res.status) {
					const handleData = res.data.items.map((item: any) => ({
						created_at: item.created_at,
						description: item.product ? item.product.description : "",
						id: item.product ? item.product.id : "",
						image: item.product && item.product.image ? (typeof item.product.image === 'object' ? item.product.image[lang] || item.product.image.en || item.product.image.vi || "" : item.product.image) : "",
						image_url: item.product && item.product.image ? (typeof item.product.image === 'object' ? item.product.image[lang] || item.product.image.en || item.product.image.vi || "" : item.product.image) : "",
						subtitle: item.product ? item.product.subtitle : "",
						title: item.product ? item.product.title : "",
						updated_at: item.updated_at,
						product_id: item.product ? item.product.product_id : "",
						product: item.product ? item.product : null,
					}));
					console.log("handleData", handleData)
					const fillterNull = handleData.filter((item: any) => item.product !== null);

					setBoughtProducts(fillterNull);
				} else {
					message.error("Failed call data", res.message);
				}
			} catch (error: any) {
				message.error("Failed call data", error);
			}
		}
	}

	function formatDate(input: any): any {
		const [datePart] = input.split(" ");
		const [year, month, day] = datePart.split("-");

		return `${day}/${month}/${year}`;
	}


	useEffect(() => {
		getRecommend()
		getBoughtProducts()
	}, [])

	return (
		<Layout>
			<Helmet>
				<title>
					{notificationCount === 0
						? ''
						: `(${notificationCount}) `}
					Lumir Products</title>
				<meta name="description" content="Lumir Products" />
			</Helmet>
			<ScrollUnlocker />
			<div className='numerologist-product'>
				<div className="w-full header-content flex justify-between">
					<h2 className="!text-lg font-semibold title-latest-product text-[var(--primary-color)]">{t('lastedProducts')}</h2>
				</div>
				{product2.length > 0 && <ProductSlider products={product2} />}
				{boughtProducts.length > 0 && <h2 className='title-product !text-lg font-semibold title-latest-product text-[var(--primary-color)]'>{t('MyProduct')}</h2>}
				{boughtProducts.length > 0 && <ProductContent data={boughtProducts} typeC={1} />}
				<h2 className='title-product !text-lg font-semibold title-latest-product text-[var(--primary-color)]'>{t('YOURRECOMMENDATIONS')}</h2>
				<ProductContent2 data={products} typeC={2} />
			</div>
		</Layout>
	);
}

export default Products;